var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 6.66406V5.83073C14.1667 3.53323 12.2975 1.66406 10 1.66406C7.70251 1.66406 5.83334 3.53323 5.83334 5.83073V8.33073H5.00001C4.08084 8.33073 3.33334 9.07823 3.33334 9.9974V16.6641C3.33334 17.5832 4.08084 18.3307 5.00001 18.3307H15C15.9192 18.3307 16.6667 17.5832 16.6667 16.6641V9.9974C16.6667 9.07823 15.9192 8.33073 15 8.33073H7.50001V5.83073C7.50001 4.4524 8.62168 3.33073 10 3.33073C11.3783 3.33073 12.5 4.4524 12.5 5.83073V6.66406H14.1667ZM15 9.9974L15.0017 16.6641H5.00001V9.9974H15Z",
    fill: "#07BC0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.639c8b925162a772de8c48dd6e18f416.svg";
export { ForwardRef as ReactComponent };